import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../Context/store/context";
import { useNavigate } from "react-router-dom";
import { _showToast } from "../../../toastHelper";
import { _post, _put } from "../../../apiClient";
import globals from "../../../globals";
import { IconUpload } from '@tabler/icons-react';
import { uploadImage } from "../../Services/ImageService";
import ImageCropping from "../../Common/Image/ImageCropping";


export default function EditUser() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const { showLoader, hideLoader, getToken, logoutuser, updateTitleAndIcon, fetchUserDetails } = useAuth();
  const [profileImageUrl, setProfileImageUrl] = useState("/images/user3.png");
  const [coverImageurl, setCoverImageUrl] = useState("/images/bannerimg01.jpg");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setstate] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [tagline, settagline] = useState("");
  const [errors, setErrors] = useState({});
  const [emailError, setEmailError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [showCropperModal, setshowCropperModal] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imageType, setImageType] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const userDetails = useSelector((state) => state.admininfo.admininfo);

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.editProfile.title, globals.editProfile.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      if (userDetails.profileImage) {
        setProfileImageUrl(userDetails.profileImage);
      }

      if (userDetails.coverImage) {
        setCoverImageUrl(userDetails.coverImage);
      }
      setFirstName(userDetails.firstName);
      setLastName(userDetails.lastName);
      settagline(userDetails.tagLine ?? "");
      setEmail(userDetails.email ?? "");
      setPhoneNumber(userDetails.contactNo ?? "");
      setDob(userDetails.dob?.split("T")[0] ?? "");
      setAddressLine1(userDetails.addressLine1 ?? "");
      setAddressLine2(userDetails.addressLine2 ?? "");
      setCity(userDetails.city ?? "");
      setstate(userDetails.state ?? "");
      setCountry(userDetails.country ?? "");
      setPinCode(userDetails.pinCode ?? "");
    }
  }, [userDetails]);


  useEffect(() => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
    if (email && !emailPattern.test(email)) {
      setEmailError("Invalid email address.");
    } else {
      setEmailError("");
    }
  }, [email]);

  useEffect(() => {
    const phoneNumberPattern = /^[6-9]\d{9}$/;
    if (phoneNumber && !phoneNumberPattern.test(phoneNumber)) {
      setPhoneNumberError("Invalid phone number. ");
    } else {
      setPhoneNumberError("");
    }
  }, [phoneNumber]);


  const handleBannerImageChange = (event) => {
    showCropper(event, 'cover');
  }

  const handleProfileImageChange = (event) => {
    showCropper(event, 'profile');
  };

  const showCropper = (event, type) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (validateFile(file)) {
        setImageType(type);
        setImageFile(file);
        setshowCropperModal(true);
      }
      else {
        if (type == "cover") {
          document.getElementById("coverPicInput").value = null;
        }
        else if (type == 'profile') {
          document.getElementById("profilePicInput").value = null;
        }
      }
    }
  }

  const validateFile = (file) => {
    let imageType = /image.*/;
    if (file && file.size > 1048576) {
        _showToast("Maximum file size allowed is 1MB, please try with different file.", "error");
        return false;
    }

    if (!file.type.match(imageType)) {
        _showToastt("File types with extension " + file.name.split('.').pop() + " are not supported.", "error");
        return false;
    }
    return true;
}

  const handleCropSave = (croppedImage, type) => {
    const file = croppedImage;
    const imageUrl = URL.createObjectURL(file);
    let container = new DataTransfer();
    container.items.add(file);

    if (type == "cover") {
      setCoverImageUrl(imageUrl);
      document.getElementById("coverPicInput").files = container.files;
    }
    else if (type == "profile") {
      setProfileImageUrl(imageUrl);
      document.getElementById("profilePicInput").files = container.files;
    }
    setshowCropperModal(false);
    setImageFile(null);
    setImageType(null);
  };

  const handleModalClose = () => {
    setshowCropperModal(false);
    document.getElementById("coverPicInput").value = null;
    document.getElementById("profilePicInput").value = null;
  };

  const handleSave = async (e) => {
    e.preventDefault();

    let validationErrors = {};
    if (!firstName) validationErrors.firstName = "FirstName is required";
    if (!lastName) validationErrors.lastName = "LastName is required";
    if (!phoneNumber) validationErrors.phoneNumber = "Contact Number is required";
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;
    showLoader();
    let coverImagekey = "";
    if (document.getElementById("coverPicInput").files && document.getElementById("coverPicInput").files.length > 0) {
      coverImagekey = await uploadImage("cover", document.getElementById("coverPicInput").files[0], "", "Cover");
    }

    let profileImageKey = "";
    if (document.getElementById("profilePicInput").files && document.getElementById("profilePicInput").files.length > 0) {
      profileImageKey = await uploadImage("profile", document.getElementById("profilePicInput").files[0], "", "Profile");
    }

    if (await saveData(coverImagekey, profileImageKey)) {
      await fetchUserDetails();
      hideLoader();
      return Navigate("/profile");
    }
  };


  const saveData = async (coverImagekey, profileImageKey) => {
    let data = {
      "id": userDetails.id,
      "firstName": firstName,
      "lastName": lastName,
      "email": email,
      "contactNo": phoneNumber,
      "tagLine": tagline,
      "dob": dob != "" ? dob : null,
      "coverImagePath": coverImagekey,
      "profileImagePath": profileImageKey,
      "addressLine1": addressLine1,
      "addressLine2": addressLine2,
      "city": city,
      "state": state,
      "country": country,
      "pinCode": pinCode
    }
    return await _put("/app-users", data)
      .then((response) => {
        _showToast("Profile information successfully updated", "success");
        return true;
      }).catch(error => {
        hideLoader();
        _showToast(error, "error");
        return false;
      });
  }

  return (
    <div className="content-wrapper">
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="card mb-4">
          <div className="card-body">
            <form id="formAccountSettings" onSubmit={handleSave}>
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label htmlFor="coverPicInput" className="form-label">
                    Cover Banner Image
                  </label>
                  <div className="d-flex align-items-start align-items-sm-center gap-4">
                    <img
                      src={coverImageurl}
                      alt="cover-banner"
                      className="d-block w-px-100 h-px-100 rounded"
                      style={{ objectFit: "cover" }}
                    />
                    <div className="button-wrapper">
                      <label
                        htmlFor="coverPicInput"
                        className="btn btn-primary me-2 mb-3"
                        tabIndex="0"
                      >
                        <span>
                          <IconUpload className="me-1" size={20} />
                          Change Cover
                        </span>
                        <input
                          type="file"
                          id="coverPicInput"
                          className="account-file-input"
                          hidden
                          accept="image/png, image/jpeg"
                          onChange={handleBannerImageChange}
                        />
                      </label>
                      <div className="text-muted fs-11">
                        Allowed JPG, GIF, or PNG. <br />Maximum File Size: 1MB
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="profilePicInput" className="form-label">
                    Profile Pic
                  </label>
                  <div className="d-flex align-items-start align-items-sm-center gap-4">
                    <img
                      src={profileImageUrl}
                      alt="user-avatar"
                      className="d-block w-px-100 h-px-100 rounded"
                      style={{ objectFit: "cover" }}
                    />

                    <div className="button-wrapper">
                      <label
                        htmlFor="profilePicInput"
                        className="btn btn-primary me-2 mb-3"
                        tabIndex="0">
                        <span>
                          <IconUpload className="me-1" size={20} />
                          Change Profile Pic
                        </span>
                        <input
                          type="file"
                          id="profilePicInput"
                          className="account-file-input"
                          hidden
                          accept="image/png, image/jpeg"
                          onChange={handleProfileImageChange}
                        />
                      </label>
                      <div className="text-muted fs-11">
                        Allowed JPG, GIF, or PNG. <br />Maximum File Size: 1MB
                      </div>
                    </div>
                  </div>
                </div>

                <hr className="my-3" />
                <div className="mb-3 col-md-6">
                  <label htmlFor="firstName" className="form-label">
                    First Name{" "}
                    <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={firstName}
                    placeholder="Enter Your First Name"
                    onChange={(e) => setFirstName(e.target.value)}
                    autoFocus
                  />
                  {errors.ProfileName && (
                    <div style={{ color: "red" }}>{errors.ProfileName}</div>
                  )}
                </div>
                <div className="mb-3 col-md-6">
                  <label htmlFor="lastName" className="form-label">
                    Last Name
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="lastName"
                    id="lastName"
                    value={lastName}
                    placeholder="Enter Your Last Name"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
                <div className="mb-3 col-md-6">
                  <label htmlFor="tagline" className="form-label">
                    TagLine
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="tagline"
                    name="tagline"
                    placeholder="Editor,Photoghrapher..."
                    value={tagline}
                    onChange={(e) => settagline(e.target.value)}
                  />
                </div>
                <div className="mb-3 col-md-6">
                  <label htmlFor="email" className="form-label">
                    E-mail
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="email"
                    name="email"
                    value={email}
                    placeholder="Enter Your Email Address Here"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {emailError && (
                    <div style={{ color: "red" }}>{emailError}</div>
                  )}
                  {errors.email && (
                    <div style={{ color: "red" }}>{errors.email}</div>
                  )}
                </div>
                <div className="mb-3 col-md-6">
                  <label className="form-label" htmlFor="phoneNumber">
                    Contact Number
                    <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                  </label>
                  <input
                    type="text"
                    id="phone-Number"
                    name="phoneNumber"
                    className="form-control"
                    placeholder="Enter your contact number here"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    onInput={(e) => {
                      if (e.target.value.length > 10) {
                        e.target.value = e.target.value.slice(0, 10);
                      }
                    }}
                    maxLength="10"
                  />
                  {phoneNumberError && (
                    <div style={{ color: "red" }}>{phoneNumberError}</div>
                  )}
                  {errors.phoneNumber && (
                    <div style={{ color: "red" }}>{errors.phoneNumber}</div>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="zipCode" className="form-label">
                    {" "}
                    Date Of Birth
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="zipCode"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    name="zipCode"
                    placeholder="231465"
                    maxLength="6"
                    max={today}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="addressLine1" className="form-label">
                    Address Line 1
                  </label>
                  <textarea
                    className="form-control"
                    id="addressLine1"
                    name="addressLine1"
                    placeholder="Enter Address Line 1"
                    rows="2"
                    maxLength="500"
                    value={addressLine1}
                    onChange={(e) => setAddressLine1(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="addressLine2" className="form-label">
                    Address Line 2
                  </label>
                  <textarea
                    className="form-control"
                    id="addressLine2"
                    name="addressLine2"
                    placeholder="Enter Address Line 2"
                    rows="2"
                    maxLength="500"
                    value={addressLine2}
                    onChange={(e) => setAddressLine2(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="city" className="form-label">
                    City
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                    placeholder="Enter Your City"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="state" className="form-label">
                    State
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="state"
                    name="state"
                    placeholder="Enter Your State Name"
                    value={state}
                    onChange={(e) => setstate(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="country" className="form-label">
                    Country
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="country"
                    name="country"
                    placeholder="Enter Your Country"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="pinCode" className="form-label">
                    Pin Code
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pinCode"
                    name="pinCode"
                    placeholder="Enter Your Pin Code"
                    value={pinCode}
                    onChange={(e) => setPinCode(e.target.value)}
                  />
                </div>
              </div>

              <div className="mt-2 d-flex justify-content-end">
                <button type="submit" className="btn btn-primary me-2">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {imageFile && showCropperModal && (
        <ImageCropping
          imageFile={imageFile}
          onClose={handleModalClose}
          onCrop={handleCropSave}
          imageType={imageType}
        />)}
    </div>
  );
}
